import React from 'react'
import styled from 'styled-components'

const Rating=styled.span`
font-size: 14px;
i{
    font-size: 12px;
    color: #ffb400;
    margin: 1px;
}
`;

export default function RatinigClient() {
    return (
        <Rating>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
            <i className="fas fa-star"></i>
        </Rating>
    )
}
